import React from 'react';
import { Input } from '@asigna/kit';
import cx from 'classnames';

interface NotesInputProps {
  placeholder?: string;
  onChange: (val: string) => void;
  onBlur?: () => void;
  value: string;
  className?: string;
}

export const MAX_NOTES_LENGTH = 100;

export const NotesInput: React.FC<NotesInputProps> = ({
  placeholder,
  onChange,
  onBlur,
  value,
  className,
}) => {
  return (
    <div className={cx('flex flex-col w-full gap-8', className)}>
      <Input
        label="Notes"
        value={value}
        type="text"
        onChange={(e) => {
          onChange(e.target.value);
        }}
        size="xs"
      />
      <div className="text-r12 text-regular">
        <span className={value.length > MAX_NOTES_LENGTH ? 'text-error' : 'text-white'}>
          {value.length}
        </span>
        /<span className="text-regular">{MAX_NOTES_LENGTH}</span>
      </div>
    </div>
  );
};
